import { IS_LOADING } from './types';

export const isLoading = (status, message = 'Loading') => (dispatch) => {
	dispatch({ type: IS_LOADING, status: status, message: message });
}